<!-- TODO: Delet once no longer used by new rating page -->
<template>
  <div class="ratingSection" :style="cssVars">
    <v-progress-circular
      :value="score * 10"
      class="ratingCircle"
      :size="newDiameter"
      :width="0.07 * newDiameter"
      :color="ratingColors[parseInt(score - 1)]"
    >
      <span class="score">{{ score % 1 === 0 ? parseInt(score) : score.toFixed(1) }}</span>
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "rating-circle-legacy",
  props: ["score", "diameter"],
  data: () => ({
    ratingColors: [
      "#880000",
      "#bf0000",
      "#ff4000",
      "#ff8000",
      "#ffbf00",
      "#ffff00",
      "#bfff00",
      "#80ff00",
      "#40ff00",
      "#00ff00",
    ],
  }),
  computed: {
    cssVars() {
      return {
        "--innerFontSize": this.newDiameter * 0.037 + "em",
      };
    },
    newDiameter() {
      return this.diameter ? this.diameter : 100;
    },
  },
};
</script>

<style scoped>
.ratingSection {
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scaleX(-1);
}
.score {
  color: var(--v-text-base);
  font-size: var(--innerFontSize);
  transform: scaleX(-1);
}
</style>
